import React, { useEffect, useState, useRef } from "react";
import NegativeRateTTD from "../ChatBody/NegativeRatingTTD";

function RatingComp({ message, giveRatings, scrollableDivRef }) {
    const [rating, setRating] = useState("");
    const [negativeRate, setNegativeRate]= useState(false)
    const [dropdownPosition, setDropdownPosition] = useState('bottom');
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(()=>{
        if(message?.hasOwnProperty("reaction") && message?.reaction === "P"){
            setRating("P")
        }else if(message?.hasOwnProperty("reaction") && message?.reaction === "N"){
            setRating("N")
        }else{
            setRating("")
        }
    },[])


    const toggleDropdown = () => {
        setNegativeRate(!negativeRate);
        if (buttonRef.current && dropdownRef.current && scrollableDivRef.current) {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            const divRect = scrollableDivRef.current.getBoundingClientRect();
        
            const spaceAbove = buttonRect.top - divRect.top;
            const spaceBelow = divRect.bottom - buttonRect.bottom;
        
            const dropdownHeight = dropdownRef.current.offsetHeight;
            console.log(spaceBelow, dropdownHeight, spaceAbove, "spaceBelow 32")
            if (spaceBelow < dropdownHeight && spaceAbove >= dropdownHeight) {
                setDropdownPosition('top');
            } else {
                setDropdownPosition('bottom');
            }
        }
    };

    const handleNegRating=(reason)=>{
        giveRatings("N", message, reason)
        setRating("N")
    }
    return (
        <>
            {
                rating === "P" ?
                    <i className="ttd ttd-thumbup positive-rating"></i>
                    :
                rating === "N" ?
                    <i className="ttd ttd-thumbdown negative-rating"></i>
                :
                    <>
                        <i className="ttd ttd-thumbup" onClick={() => { giveRatings("P", message); setRating("P") }}></i>
                        <i className="ttd ttd-thumbdown" ref={buttonRef} onClick={() => { toggleDropdown() }}></i>
                        <NegativeRateTTD negativeRate={negativeRate} setNegativeRate={setNegativeRate} handleNegRating={handleNegRating} 
                        scrollableDivRef={scrollableDivRef} dropdownPosition={dropdownPosition} dropdownRef={dropdownRef} />
                    </>
            }
        </>
    );
}

export default RatingComp;
